exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title-description[data-v-49b16389] {\n    max-width: 60%;\n}\n", ""]);

// exports
